import Cookies from "js-cookie";

(function ($) {
  $(".btn-logout").on("click", async function (e) {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://www.numberguru.com/api/v5/session",
        {
          method: "DELETE",
          credentials: "include",
        },
      );

      if (response.ok) {
        Cookies.remove("loggedin");
        Cookies.remove("loggedinas");
        Cookies.remove("full_name");
        Cookies.remove("user_code");

        location.reload();
      }
    } catch (err) {
      console.log(err);
    }
  });

  $(".has-tooltip").on("click", function (e) {
    e.preventDefault();
    const tooltip = $(this).find(".tooltip");
    const clipboardText = $(this).find("span").text();
    navigator.clipboard.writeText(clipboardText);
    $(tooltip).text("Copied!");
  });
  $(".has-tooltip").on("mouseout", function () {
    const tooltip = $(this).find(".tooltip");
    tooltip.text("Click to copy.");
  });
})($);
